<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Agent
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Agent</a>
          </li>
      </ul>
    </div>
    <!-- <router-view @refresh="refresh()"></router-view> -->
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> Agent
      </template> -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="5">
            From
            <b-form >
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="5">
            To
            <b-form >
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Name</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" v-model="so.opt.name" :placeholder="'typing name'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Host</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" v-model="so.opt.host" :placeholder="'typing host'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>

        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Version</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" v-model="so.opt.version" :placeholder="'typing version'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>IP</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" v-model="so.opt.ip_addr" :placeholder="'typing ip'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Backup Mode</span> </b-form> </b-col>
          <b-col>
            <b-form-radio-group
              id="radio-group-2"
              v-model="so.opt.backup_mode"
              v-b-tooltip.hover
              title="Please enter the Usage Backup Mode you want to search for"
            >
              <b-form-radio :value="true" @click="so.sv=`setting.backup_mode`">Used</b-form-radio>
              <b-form-radio :value="false" @click="so.sv=`setting.backup_mode`">Disable</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <hr>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="dark" @click="so.adv = false"> Exit </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="6" v-if="only_select == true">
          <b-button size="sm" variant="primary" @click="multi_all"> Select All </b-button>
          <b-button size="sm" variant="warning" @click="multi_clear"> Clear </b-button>
        </b-col>
        <b-col sm="6" v-else>
          <span class="text-center" v-b-tooltip.hover title="Specify the number of views on one page">
            Show Count
            <select v-model="so.perPage" @change="refresh">
              <option value="15">Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='Name';so.adv=false;so.sv=''">Name</b-dropdown-item>
                <!-- <b-dropdown-item size="sm" @click="so.sk='tag';so.skt='Tag';so.adv=false;so.sv=''">Tag</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='host';so.skt='Host';so.adv=false;so.sv=''">Host</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='ip_addr';so.skt='IP';so.adv=false;so.sv=''">IP</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='version';so.skt='version';so.adv=false;so.sv=''">Version</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv"  @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv; so.sv = ''"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> Detail Search</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <!-- select-mode="multi" selectable @row-selected="onRowSelected" 로 변경하여 코드 간결화 필요 -->
      <b-table
        class="text-center table-responsive table_add"
        :tbody-tr-class="rowClass"
        ref="_list"
        responsive="sm"
        striped hover small fixed :items="getItems"
        :fields="fields"
        :current-page="so.currentPage"
        empty-text="not found"
        :per-page="so.perPage"
        v-show="agents && agents.length"
        :sortBy="so.sk"
        @row-clicked="multi_click"
        style="cursor:pointer;"
        >
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template slot="id" slot-scope="row">
          {{only_select != true ? startRow - row.index : ''}}
          <b-form-checkbox :disabled="agent_id == row.item.id" v-if="only_select" v-model="row.item.check" @change="multi_one($event, row)"></b-form-checkbox>
        </template>

        <template slot="is_use" slot-scope="row" v-show="this.agents[row.index].ms">
          <b-badge variant="success" v-if="row.item.alive">
            <span v-if="row.item.alive && row.item.scanning">
              <span v-if="row.item.is_real_time === false"> Self </span>
              Scanning
            </span>
            <span v-else>Online</span>
            <!-- {{ row.item.real_time ? '' : '' }} {{row.item.alive && row.item.scanning ? '점검중' : '온라인' }}  -->
            {{ row.item.ms ? ` (${row.item.ms} ms)` : ''}}
          </b-badge>
          <b-badge v-else>Offline</b-badge>
          <b-progress-bar class="animated fadeIn fadeOut" style="height: 15px;" v-if="row.item.alive &&row.item.scanning" show-progress animation :precision="1" :value="row.item.progress|| 0" :variant="row.item.is_real_time ? 'warning' : 'info'"></b-progress-bar>
        </template>
        <template slot="name" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{ row.item.name || '-'}}
          </a>
        </template>
        <template slot="host" slot-scope="row">{{ row.item.host }}</template>
        <template slot="os_type" slot-scope="row">{{ row.item.version }} - {{ row.item.os_type }}</template>
        <template slot="ip_addr" slot-scope="row">
          <span v-if="!row.item.ip_addr_public || !row.item.ip_addr_private">{{row.item.ip_addr}}</span>
          <span v-else>
            <span v-if="row.item.ip_addr_public">
              <span v-if="row.item.ip_addr_public == row.item.ip_addr_private">
                {{ row.item.ip_addr_public }}
              </span>
              <span v-else>
                {{ row.item.ip_addr_public }} /  {{ row.item.ip_addr_private }}
              </span>
            </span>
            <span v-else>
              {{ row.item.ip_addr_private }}
            </span>
          </span>
        </template>
        <template slot="created_at" slot-scope="row">{{ row.item.created_at | sdate }}</template>>
        <template slot="select" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <template v-if="!agents || agents && !agents.length">
        <b-card>
          <tr>
            <th>No agents installed</th>
          </tr>
        </b-card>
      </template>
      <b-row>
        <b-col md="3"></b-col>
        <b-col md="5">
          <b-pagination size="sm"  align="center" :total-rows="so.totalRows" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4" v-if="only_select != true">
          <div class="pull-right">
            <b-button class="btn-add" size="sm" variant="outline-warning" @click="all.type = 'upgrade'; all.modal = true;"> Update All </b-button>
            <b-button size="sm" variant="primary" @click="all.type = 'start'; all.modal = true;"> Start Scan All </b-button>
            <b-button size="sm" variant="danger" @click="all.type = 'stop'; all.modal = true;"> Stop Scan All </b-button>
            <!-- <b-button class="btn-addition" size="sm" variant="primary" @click="$router.replace(`/downloads/`)">Agent Download</b-button> -->
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="all.modal" ref="upgrade_all" title="Controls all agents" @ok="all.modal = false; all.confirm = true; all_cmd()" no-close-on-backdrop header-bg-variant="danger">
      <h5>Commands to be sent to the entire agent: [{{all.type}}]</h5>
      <hr>
      <h6> <b>Are you sure this action?</b></h6>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
